import { formatCentsAsMollieAmount } from '@yoga-tool/shared';

export function formatPrice(cents: number, currency = 'CHF'): string {
  const amount = formatCentsAsMollieAmount(cents);
  if (currency === 'CHF') {
    return `CHF ${amount}`;
  }
  return `${currency} ${amount}`;
}

export function formatSessionDate(iso: string): string {
  const date = new Date(iso);
  return new Intl.DateTimeFormat('de-CH', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function formatSessionTime(startIso: string, endIso: string): string {
  const start = new Date(startIso);
  const end = new Date(endIso);
  const formatter = new Intl.DateTimeFormat('de-CH', {
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${formatter.format(start)} – ${formatter.format(end)} Uhr`;
}

export function productTypeLabel(type: string): string {
  switch (type) {
    case 'trial':
      return 'Schnupper-Angebot';
    case 'single_class':
      return 'Einzelstunde';
    case 'credit_pack':
      return '10er-Abo';
    default:
      return type;
  }
}
